import { useEffect, useState } from 'react';
import { ordersService } from '../../services/orders.service';

const PAGE_SIZE = 100;
const MAX_PAGES = 10;

async function fetchAllOrders() {
  let orders = [];
  let cursor;
  for (let page = 0; page < MAX_PAGES; page += 1) {
    // eslint-disable-next-line no-await-in-loop
    const result = await ordersService.listOrders({ limit: PAGE_SIZE, cursor });
    const pageOrders = Array.isArray(result?.orders) ? result.orders : [];
    orders = orders.concat(pageOrders);
    cursor = result?.nextCursor || null;
    if (!cursor) break;
  }
  return orders;
}

export const useOrdersActivityData = () => {
  const [state, setState] = useState({ loading: true, orders: [], failed: false });

  useEffect(() => {
    let active = true;
    fetchAllOrders()
      .then((orders) => {
        if (!active) return;
        setState({ loading: false, orders, failed: false });
      })
      .catch(() => {
        if (!active) return;
        setState({ loading: false, orders: [], failed: true });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
};
